function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33229 9H1.66771C1.5278 9 1.44968 9.21194 1.53632 9.35664L3.86861 13.2368C3.93537 13.3479 4.06392 13.3479 4.13139 13.2368L6.46368 9.35664C6.55032 9.21194 6.4722 9 6.33229 9Z",
  fill: ""
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1.66771 7.32031L6.33229 7.32031C6.4722 7.32031 6.55032 7.10837 6.46368 6.96368L4.13139 3.08347C4.06463 2.9724 3.93608 2.9724 3.86861 3.08347L1.53632 6.96368C1.44968 7.10837 1.5278 7.32031 1.66771 7.32031Z",
  fill: ""
});

var SvgCaretUpDown = function SvgCaretUpDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretUpDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret_up_down.00a7a673.svg";
export { ForwardRef as ReactComponent };